import { render } from "./Alerts.vue?vue&type=template&id=ade3ba20&scoped=true&ts=true"
import script from "./Alerts.vue?vue&type=script&lang=ts"
export * from "./Alerts.vue?vue&type=script&lang=ts"

import "./Alerts.vue?vue&type=style&index=0&id=ade3ba20&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ade3ba20"]])

export default __exports__